module.exports = __webpack_public_path__ + "img/educated.88179ccd.svg";